/**
 * Internal Dependencies
 */
import updateCurrentBid from "@/frontend/domain/auction/update-current-bid";

(async () => {
  const $bidTotal = document.querySelector('.js-bid-total');
  const productId = window._bdmDealOptions.productId;
  if (!$bidTotal || !productId) {
    return;
  }

  setInterval(async () => {
    updateCurrentBid();
  }, 5000);
})();
